import { useEffect } from 'react';
import { isMobile } from '../../../utils/mainLayoutUtils';

/**
 * Hook to manage sidebar behavior for MainLayout component
 * @param {boolean} isSidebarCollapsed - Current sidebar collapsed state
 * @param {Function} setIsSidebarCollapsed - Setter for sidebar collapsed state
 */
export const useMainLayoutSidebar = (isSidebarCollapsed, setIsSidebarCollapsed) => {
  // Handle window resize to collapse sidebar on mobile
  useEffect(() => {
    const handleResize = () => {
      if (isMobile() && !isSidebarCollapsed) {
        setIsSidebarCollapsed(true);
      }
    };

    window.addEventListener('resize', handleResize);
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, [isSidebarCollapsed, setIsSidebarCollapsed]);
};
